var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServientrega(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 230 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:url(#Degradado_sin_nombre_143);}.cls-2{stroke:#fff;stroke-width:1.8px;fill:url(#Degradado_sin_nombre_4);}.cls-2,.cls-3,.cls-4,.cls-5{fill-rule:evenodd;}.cls-3{fill:url(#Degradado_sin_nombre_2);}.cls-4,.cls-6{fill:#fff;}.cls-5{fill:url(#Degradado_sin_nombre_3);}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_143",
    x1: 115,
    y1: 221.68,
    x2: 115,
    y2: 6.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24ab5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0d602e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: -178.74,
    y1: 484.88,
    x2: -178.67,
    y2: 487.24,
    gradientTransform: "matrix(28.19, 0, 0, -28.31, 5157.21, 13858.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56c271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    x1: -173.09,
    y1: 425.85,
    x2: -170.79,
    y2: 425.85,
    gradientTransform: "matrix(17.01, 0, 0, -7.75, 3041.64, 3382.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    x1: -172.82,
    y1: 421.81,
    x2: -170.52,
    y2: 421.81,
    gradientTransform: "matrix(16.93, 0, 0, -7.54, 3028.64, 3288.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5c5c5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 230,
    height: 230
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo-nuevo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-2",
    d: "M117.53,63.35h34.56V98.09a30.28,30.28,0,0,1-30.21,30.31H87.32V93.7A30.28,30.28,0,0,1,117.53,63.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "cls-3",
    d: "M136.36,85.71c-2.41-4.19-7.14-6.54-12.83-6.54a23.73,23.73,0,0,0-20.68,13.65h-2.51a3.09,3.09,0,0,1-2.68-4.58h0C106.69,73.41,130.27,69,136.36,85.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    className: "cls-4",
    d: "M136.36,85.7h7.14a20.72,20.72,0,0,0-20-13.35A29.86,29.86,0,0,0,97.77,88.12C106.69,73.39,130.29,69.07,136.36,85.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    className: "cls-4",
    d: "M103.12,106H96c2.8,8.07,10.71,13.32,20,13.32a29.84,29.84,0,0,0,25.6-15.46C134,116.55,110.39,123.31,103.12,106Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    className: "cls-4",
    d: "M142.57,95.06a5.48,5.48,0,0,0-4.69-2.24H100.39a3.11,3.11,0,0,1-2.87-4.18,25.3,25.3,0,0,0-1.27,3,5.52,5.52,0,0,0,.64,5.13,5.63,5.63,0,0,0,4.7,2.34h37.49a3.13,3.13,0,0,1,2.42,1.51,3.21,3.21,0,0,1,.22,2.86,28.52,28.52,0,0,0,1.52-3.44,5.4,5.4,0,0,0-.67-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    className: "cls-5",
    d: "M139,99.1h-2.41a23.7,23.7,0,0,1-20.64,13.63,14.26,14.26,0,0,1-12.8-6.69c7.3,17.29,31,10.47,38.49-2.19h0a3.21,3.21,0,0,0,0-3.12A3.16,3.16,0,0,0,139,99.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-6",
    d: "M94.8,157.24a.42.42,0,0,1-.41.41H93a.42.42,0,0,1-.41-.41V144.07a.42.42,0,0,1,.12-.28.4.4,0,0,1,.29-.12h1.33a.38.38,0,0,1,.29.12.38.38,0,0,1,.12.28ZM90,143.93h-1.2a.55.55,0,0,0-.59.31l-4.13,10-4.14-10a.58.58,0,0,0-.6-.33H78.16a.42.42,0,0,0-.32.16.57.57,0,0,0-.07.59l5.17,12.49a.73.73,0,0,0,.59.48h1.16a.79.79,0,0,0,.61-.51l5.18-12.49a.52.52,0,0,0-.1-.58.42.42,0,0,0-.34-.17Zm-13.94,1-.53,1a.45.45,0,0,1-.11.13.63.63,0,0,1-.75.09,1.91,1.91,0,0,0-.32-.16,3.73,3.73,0,0,0-3.53.33,3.78,3.78,0,0,0-1.68,3.14v7.82a.44.44,0,0,1-.11.29.39.39,0,0,1-.3.12H67.44a.41.41,0,0,1-.41-.41V144.31a.42.42,0,0,1,.41-.41h.31a1.38,1.38,0,0,1,1.42,1.16,5.27,5.27,0,0,1,3.76-1.58h.15a5.22,5.22,0,0,1,2.16.47l.71.37a.43.43,0,0,1,.15.57Zm-32,4.4-.46-.07c-1.45-.26-3.26-.58-3.3-1.84a1.27,1.27,0,0,1,.39-1,4.07,4.07,0,0,1,2.87-.85h.08a5.17,5.17,0,0,1,3.09.79c.07,0,.23.17.45.34a.64.64,0,0,0,.84-.06l.54-.58a.65.65,0,0,0,.17-.56.72.72,0,0,0-.24-.39c-.29-.25-.5-.41-.62-.5a7.41,7.41,0,0,0-4.24-1.19h-.12a6.16,6.16,0,0,0-4.38,1.5,3.4,3.4,0,0,0-1,2.56c0,3,3,3.5,5.33,3.9,2.55.41,3.76.86,3.73,2-.07,1.78-2.46,2-3.48,2a6.09,6.09,0,0,1-2.84-.7,4.72,4.72,0,0,1-1.33-1.15.57.57,0,0,0-.5-.24.62.62,0,0,0-.43.16l-.66.6a.64.64,0,0,0-.08.85,7.24,7.24,0,0,0,1.61,1.47,7.88,7.88,0,0,0,4.25,1.15c5.18,0,5.66-3.08,5.69-4C49.6,150.23,46.33,149.68,44.12,149.31ZM174,155.43a6.85,6.85,0,0,0,1.35-9.69l1-1.16a.47.47,0,0,0,0-.51,1.4,1.4,0,0,0-1.84-.41,1.61,1.61,0,0,0-.38.31l-.34.41a6.89,6.89,0,0,0-3.5-1c-3.86,0-6.44,2.68-6.44,6.69a6.33,6.33,0,0,0,6.44,6.65c2,0,4.32.85,4.32,3.33,0,3.12-3.3,3.41-4.32,3.41-1.87,0-4-.76-4.24-2.9v-.33a.42.42,0,0,0-.41-.41h-1.32a.42.42,0,0,0-.4.41v.11a2.54,2.54,0,0,0,0,.39c.3,3,2.81,4.94,6.42,4.94,4,0,6.48-2.14,6.48-5.57a4.94,4.94,0,0,0-2.83-4.67Zm-3.65-.94a4.15,4.15,0,0,1-3.07-1.28,4.21,4.21,0,0,1-1.17-3.14c0-2.16,1.1-4.47,4.24-4.47a4.11,4.11,0,0,1,4.25,4.47,4.41,4.41,0,0,1-4.25,4.42Zm21.47-10.59h-.57a1.4,1.4,0,0,0-1,.41,1.42,1.42,0,0,0-.43,1h0a6.39,6.39,0,0,0-4.65-1.89,7,7,0,0,0,0,14.07,6.2,6.2,0,0,0,4.66-2v1.71a.41.41,0,0,0,.41.41h1.58a.42.42,0,0,0,.4-.41V144.31a.42.42,0,0,0-.37-.41Zm-6.57,11.42a4.64,4.64,0,0,1-4.7-4.86,4.77,4.77,0,1,1,9.53,0,4.66,4.66,0,0,1-1.35,3.5,4.59,4.59,0,0,1-3.48,1.36Zm-48.87,0a.63.63,0,0,0-.87-.38l-.42.18a3.46,3.46,0,0,1-1.14.23c-1.55,0-1.82-.79-1.82-2.45v-7.09h3.91a.42.42,0,0,0,.41-.4V144.3a.42.42,0,0,0-.41-.41h-3.91v-3.66a.41.41,0,0,0-.41-.41h-.46A1.28,1.28,0,0,0,130,141.1v2.8h-2.47a.42.42,0,0,0-.4.41v1.11a.4.4,0,0,0,.4.41H130v7.08c0,3.08,1.29,4.58,4,4.58a5,5,0,0,0,1.74-.34c.14-.05.42-.18.85-.37a.42.42,0,0,0,.2-.54Zm12.14-10.55-.58,1a.65.65,0,0,1-.6.34.72.72,0,0,1-.32-.08,1.37,1.37,0,0,0-.32-.16,3.8,3.8,0,0,0-5.26,3.47v7.86a.41.41,0,0,1-.41.41h-1.33a.41.41,0,0,1-.41-.41V144.31a.42.42,0,0,1,.41-.41h.38a1.38,1.38,0,0,1,1.42,1.16,5.28,5.28,0,0,1,3.77-1.58h.14a5.22,5.22,0,0,1,2.16.47,8.83,8.83,0,0,1,.8.43.31.31,0,0,1,.14.41Zm-22.61,4.7v7.77a.4.4,0,0,1-.12.29.45.45,0,0,1-.29.12h-1.34a.43.43,0,0,1-.41-.41v-7.68a3.9,3.9,0,0,0-1.07-2.9,4.15,4.15,0,0,0-3-1h-.08a3.93,3.93,0,0,0-2.9,1.21,4,4,0,0,0-1.11,2.95v7.45a.43.43,0,0,1-.41.41h-1.34a.42.42,0,0,1-.41-.41V144.36a.47.47,0,0,1,.46-.46h.23a1.39,1.39,0,0,1,1.43,1.18,5.79,5.79,0,0,1,4.07-1.65h0c3.78,0,6.25,2.34,6.25,6Zm-61.18.7c0-3.29-2.11-6.82-6.75-6.82a6.78,6.78,0,0,0-5,2,6.86,6.86,0,0,0-2,5A6.74,6.74,0,0,0,53,155.46a6.64,6.64,0,0,0,5,2,7.6,7.6,0,0,0,5.25-2c.09-.09.25-.27.47-.54a.63.63,0,0,0,.13-.56.69.69,0,0,0-.25-.38l-.62-.49a.63.63,0,0,0-.39-.15.73.73,0,0,0-.5.23,5.48,5.48,0,0,1-.4.44A6.07,6.07,0,0,1,58,155.39a4.5,4.5,0,0,1-4.61-3.6H64.64c.06-.53.09-1.06.1-1.6Zm-11.36,0A4.29,4.29,0,0,1,58,145.55c3,0,4.63,1.71,4.63,4.62Zm57.62,0c0-3.29-2.11-6.82-6.75-6.82a6.78,6.78,0,0,0-5,2,6.9,6.9,0,0,0-2,5,6.74,6.74,0,0,0,1.91,5.06,6.64,6.64,0,0,0,5,2,7.59,7.59,0,0,0,5.25-2q.13-.14.48-.54a.69.69,0,0,0,.13-.56.75.75,0,0,0-.25-.38l-.62-.49a.7.7,0,0,0-.4-.15.73.73,0,0,0-.5.23,5.48,5.48,0,0,1-.4.44,6.07,6.07,0,0,1-3.69,1.36,4.51,4.51,0,0,1-4.61-3.6h11.26s.09-.86.09-1.6Zm-11.36,0c0-2.4,1.34-4.49,4.61-4.49,3,0,4.64,1.61,4.64,4.49Zm62.47,0c0-3.29-2.11-6.82-6.75-6.82a6.78,6.78,0,0,0-5,2,6.9,6.9,0,0,0-2,5,6.71,6.71,0,0,0,1.92,5.06,6.6,6.6,0,0,0,5,2,7.57,7.57,0,0,0,5.23-1.91,6.17,6.17,0,0,0,.48-.54.65.65,0,0,0-.11-.93l-.62-.5a.65.65,0,0,0-.89.08c-.13.15-.27.3-.41.44a6.12,6.12,0,0,1-3.69,1.37,4.52,4.52,0,0,1-4.61-3.6H162a13.22,13.22,0,0,0,.11-1.66Zm-11.37,0c0-2.41,1.34-4.5,4.61-4.5,3,0,4.64,1.61,4.64,4.5Zm-55.95-9v-.92a.41.41,0,0,0-.41-.41h-.91a.85.85,0,0,0-.85.85v.92a.38.38,0,0,0,.12.29A.4.4,0,0,0,93,142H94A.85.85,0,0,0,94.8,141.15Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServientrega);
export default __webpack_public_path__ + "static/media/servientrega.37783c5db844ed029259cc995ee2fc51.svg";
export { ForwardRef as ReactComponent };